module.exports = __webpack_public_path__ + "static/media/vscode.28125f0f.svg";